import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { CodelistGroup, mapSelectOptions } from 'features/declaration/codelist/models/types'
import useCodelistQuery, { CodelistFilterFn } from 'features/declaration/codelist/api/useCodelistQuery'
import { ISelectOption } from 'types/IClassifier'

export type CodelistOptionsResult = {
  options: ISelectOption[]
  isLoading: boolean
  isSuccess: boolean
}

function useCodelistOptions(group: CodelistGroup, filterFn?: CodelistFilterFn): CodelistOptionsResult {
  const { i18n } = useTranslation()
  const { data, isLoading, isSuccess } = useCodelistQuery(group, filterFn)
  const options: ISelectOption[] = useMemo(() => mapSelectOptions(data, i18n.language), [data, i18n.language])

  return {
    options,
    isLoading,
    isSuccess,
  }
}

export default useCodelistOptions
